/* =====================================================================
   Maren Magnesium — shared product page JS
   - Gallery (prev/next + thumbs)
   - Bundle / quantity picker that updates price + form quantity
   - Variant picker that updates form id input + price
   - AJAX add-to-cart with toast
   - Sticky mobile ATC that mirrors the hero form
   Designed to attach to any element with [data-maren-*]; safe to load on
   any page (does nothing if its targets aren't there).
   ===================================================================== */
(function () {
  'use strict';

  var CURRENCY_FORMAT = (window.Shopify && window.Shopify.money_format) || '₪{{amount}}';

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return CURRENCY_FORMAT.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/g, amount);
  }

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }

  /* -------------------- Gallery -------------------- */
  function initGallery(root) {
    var slides = $$('[data-m-slide]', root);
    var thumbs = $$('[data-m-thumb]', root);
    var counter = $('[data-m-counter]', root);
    var total = $('[data-m-total]', root);
    if (!slides.length) return;
    if (total) total.textContent = String(slides.length).padStart(2, '0');
    var active = 0;
    function show(i) {
      i = (i + slides.length) % slides.length;
      active = i;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === i); });
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      if (counter) counter.textContent = String(i + 1).padStart(2, '0');
    }
    var prev = $('[data-m-prev]', root);
    var next = $('[data-m-next]', root);
    if (prev) prev.addEventListener('click', function () { show(active - 1); });
    if (next) next.addEventListener('click', function () { show(active + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-m-thumb'), 10) || 0); }); });
  }

  /* -------------------- Shades / Forms -------------------- */
  function initShades(root) {
    var btns = $$('[data-m-shade]', root);
    if (!btns.length) return;
    var nameEl = $('[data-m-shade-name]', root);
    var subEl = $('[data-m-shade-sub]', root);
    var variantInput = $('[data-m-variant-input]', root);
    function pick(btn) {
      btns.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      if (nameEl) nameEl.textContent = btn.getAttribute('data-name') || '';
      if (subEl) subEl.textContent = btn.getAttribute('data-sub') || '';
      var vid = btn.getAttribute('data-variant-id');
      if (variantInput && vid) variantInput.value = vid;
      // Broadcast for sticky ATC mirror
      document.dispatchEvent(new CustomEvent('maren:shade', {
        detail: { name: btn.getAttribute('data-name'), color: btn.getAttribute('data-color'), variantId: vid }
      }));
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
    var initial = $('[data-m-shade].is-selected', root) || btns[0];
    if (initial) pick(initial);
  }

  /* -------------------- Bundles / quantity -------------------- */
  function initBundles(root) {
    var btns = $$('[data-m-bundle]', root);
    if (!btns.length) return;
    var priceEl = $('[data-m-price]', root);
    var compareEl = $('[data-m-compare]', root);
    var saveEl = $('[data-m-save]', root);
    var atcPrice = $('[data-m-atc-price]', root);
    var variantInput = $('[data-m-variant-input]', root);
    var qtyInput = $('[data-m-quantity-input]', root);
    function pick(btn) {
      btns.forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      var price = parseFloat(btn.getAttribute('data-price')) || 0;
      var retail = parseFloat(btn.getAttribute('data-retail')) || 0;
      var save = btn.getAttribute('data-save');
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      if (priceEl) priceEl.textContent = '₪' + Math.round(price);
      if (compareEl) compareEl.textContent = retail ? '₪' + Math.round(retail) : '';
      if (saveEl) {
        if (save) { saveEl.style.display = ''; saveEl.textContent = saveEl.getAttribute('data-template').replace('{n}', save); }
        else { saveEl.style.display = 'none'; }
      }
      if (atcPrice) atcPrice.textContent = '₪' + Math.round(price);
      var vid = btn.getAttribute('data-variant-id');
      if (variantInput && vid) variantInput.value = vid;
      if (qtyInput) qtyInput.value = qty;
      document.dispatchEvent(new CustomEvent('maren:bundle', {
        detail: { price: price, retail: retail, qty: qty, variantId: vid, label: btn.getAttribute('data-label') }
      }));
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
    var initial = $('[data-m-bundle].is-selected', root) || btns[0];
    if (initial) pick(initial);
  }

  /* -------------------- Variant radio (real Shopify variants) -------------------- */
  function initVariantPicker(root) {
    var radios = $$('[data-m-variant-radio]', root);
    if (!radios.length) return;
    var variantInput = $('[data-m-variant-input]', root);
    var priceEl = $('[data-m-price]', root);
    var compareEl = $('[data-m-compare]', root);
    var atcPrice = $('[data-m-atc-price]', root);
    var atcBtn = $('[data-m-atc]', root);

    function update(r) {
      if (!r.checked) return;
      var vid = r.value;
      var price = r.getAttribute('data-price');           // in cents
      var compare = r.getAttribute('data-compare');       // in cents
      var available = r.getAttribute('data-available') === 'true';
      if (variantInput) variantInput.value = vid;
      if (priceEl && price) priceEl.textContent = formatMoney(parseInt(price, 10));
      if (compareEl) {
        if (compare && parseInt(compare, 10) > parseInt(price, 10)) {
          compareEl.textContent = formatMoney(parseInt(compare, 10));
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (atcPrice && price) atcPrice.textContent = formatMoney(parseInt(price, 10));
      if (atcBtn) {
        atcBtn.disabled = !available;
        atcBtn.setAttribute('aria-disabled', String(!available));
        var soldOutLabel = atcBtn.getAttribute('data-sold-out-label') || 'אזל מהמלאי';
        var label = atcBtn.querySelector('[data-m-atc-label]');
        if (label) label.textContent = available ? atcBtn.getAttribute('data-available-label') || label.textContent : soldOutLabel;
      }
      document.dispatchEvent(new CustomEvent('maren:variant', { detail: { variantId: vid, price: price, available: available } }));
    }
    radios.forEach(function (r) { r.addEventListener('change', function () { update(r); }); });
    var initial = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    if (initial) { initial.checked = true; update(initial); }
  }

  /* -------------------- AJAX add to cart + toast -------------------- */
  function initForm(root) {
    var form = $('[data-m-form]', root);
    if (!form) return;
    var toast = $('[data-m-toast]') || $('[data-m-toast]', root);
    var toastMsg = $('[data-m-toast-msg]') || (toast && $('[data-m-toast-msg]', toast));
    var cartCount = document.querySelector('[data-m-cart-count]');

    function showToast(msg) {
      if (!toast || !toastMsg) return;
      toastMsg.textContent = msg;
      toast.classList.add('is-visible');
      setTimeout(function () { toast.classList.remove('is-visible'); }, 2400);
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // fallback to normal submit
      e.preventDefault();
      var fd = new FormData(form);
      var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';
      addUrl = addUrl.replace(/\/+/g, '/');
      fetch(addUrl, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('cart');
          return r.json();
        })
        .then(function () {
          var qty = parseInt((fd.get('quantity') || '1'), 10) || 1;
          if (cartCount) cartCount.textContent = (parseInt(cartCount.textContent, 10) || 0) + qty;
          showToast(form.getAttribute('data-success-message') || 'נוסף לסל');
          document.dispatchEvent(new CustomEvent('maren:added', { detail: { quantity: qty } }));
          // If host theme has a cart drawer, let it know
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          form.submit();
        });
    });
  }

  /* -------------------- Sticky mobile ATC -------------------- */
  function initSticky() {
    var sticky = $('[data-m-sticky]');
    if (!sticky) return;
    document.body.classList.add('maren-has-sticky');
    var btn = $('[data-m-sticky-atc]', sticky);
    var nameEl = $('[data-m-sticky-shade-name]', sticky);
    var dotEl = $('[data-m-sticky-shade]', sticky);
    var priceEl = $('[data-m-sticky-price]', sticky);
    var wasEl = $('[data-m-sticky-was]', sticky);

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var form = $('[data-m-form]');
        if (form) (form.requestSubmit ? form.requestSubmit() : form.submit());
      });
    }
    document.addEventListener('maren:shade', function (e) {
      if (nameEl && e.detail.name) nameEl.textContent = e.detail.name;
      if (dotEl && e.detail.color) dotEl.style.background = e.detail.color;
    });
    document.addEventListener('maren:bundle', function (e) {
      if (priceEl && e.detail.price) priceEl.textContent = '₪' + Math.round(e.detail.price);
      if (wasEl) wasEl.textContent = e.detail.retail ? '₪' + Math.round(e.detail.retail) : '';
    });
    document.addEventListener('maren:variant', function (e) {
      if (priceEl && e.detail.price) priceEl.textContent = formatMoney(parseInt(e.detail.price, 10));
    });
  }

  /* -------------------- Countdown -------------------- */
  function initCountdown() {
    $$('[data-m-countdown]').forEach(function (el) {
      var endAttr = el.getAttribute('data-end');
      var end = endAttr ? new Date(endAttr).getTime() : null;
      if (!end || isNaN(end)) {
        // rolling countdown anchored at h:m:s in attribute
        var h = parseInt(el.getAttribute('data-h') || '4', 10);
        var m = parseInt(el.getAttribute('data-m') || '23', 10);
        var s = parseInt(el.getAttribute('data-s') || '11', 10);
        setInterval(function () {
          s--; if (s < 0) { s = 59; m--; }
          if (m < 0) { m = 59; h--; }
          if (h < 0) { h = 0; m = 0; s = 0; }
          el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        }, 1000);
        return;
      }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var hh = Math.floor(diff / 3600000);
        var mm = Math.floor((diff % 3600000) / 60000);
        var ss = Math.floor((diff % 60000) / 1000);
        el.textContent = String(hh).padStart(2, '0') + ':' + String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* -------------------- FAQ accordion accessibility -------------------- */
  function initFaq() {
    $$('.maren-faq__item summary').forEach(function (s) {
      s.setAttribute('role', 'button');
      var d = s.parentElement;
      s.setAttribute('aria-expanded', d && d.open ? 'true' : 'false');
      s.addEventListener('click', function () {
        // toggle happens natively; sync aria after the click
        setTimeout(function () { s.setAttribute('aria-expanded', d && d.open ? 'true' : 'false'); }, 0);
      });
    });
  }

  /* -------------------- Boot -------------------- */
  function boot() {
    $$('[data-maren-hero]').forEach(function (root) {
      initGallery(root);
      initShades(root);
      initBundles(root);
      initVariantPicker(root);
      initForm(root);
    });
    initSticky();
    initCountdown();
    initFaq();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
